/*
 * Public API Surface of ngx-soap
 */

export * from './lib/ngx-soap.service';
export * from './lib/ngx-soap.module';
